import React, { useState } from 'react'
import { Container, Form, Row, Col } from 'react-bootstrap';
import { AddDivisionApi } from './divisionAction';
import { connect } from "react-redux";
import { setHeading } from '../../../accounts/account.actions';
import { useEffect } from 'react';
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import _ from "lodash";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddDivision = (props) => {
    const [divisionName, setDivisionName] = useState();
    const [divisionDescription, setDivisionDescription] = useState();


    function uploadDivision() {
        props.AddDivisionApi({
            name: _.upperCase(divisionName),
            description: _.upperCase(divisionDescription),
        },
            showSuccessAlert,
            showErrorAlert
        );
        clearStates()
    }
    const clearStates = () => {
        setDivisionName();
        setDivisionDescription();
    }

    useEffect(() => {
        props.setHeading("Division Add");
    });

    return (
        <>
            {(props.isFetchingDivisionData || props.isAddingDivisionData) ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Form>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana" >
                                    <Form.Label><b>Division Name *</b></Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Division Name"
                                        onChange={(e) => setDivisionName(e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="garana" >
                                    <Form.Label> <b>Division Description</b> </Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        placeholder="Division Description"
                                        onBlur={(e) => setDivisionDescription(e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>

                        <div className="sendDiv">
                            {_.isEmpty(divisionName) ? (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                            ) : (
                                <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => uploadDivision()}>SAVE </Button>
                            )}
                        </div>
                    </Form>
                </Container>
            )}
        </>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        AddDivisionApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddDivisionApi(data, showSuccessAlert, showErrorAlert)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingDivisionData: state.DivisionReducer.isAddingDivisionData,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddDivision);